var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('faq')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hero-section static-secondary d-flex flex-column align-center justify-center"},[_c('h3',{staticClass:"white--text font-weight-medium text-subtitle"},[_vm._v("FAQ")])])
}]

export { render, staticRenderFns }